import React, { useContext, useEffect, useState  } from "react";
import { Route, Switch ,useLocation ,useHistory } from "react-router-dom";
import { socketContext } from "../../App";
import EnrollAudition from "../Pages/AuditionPages/EnrollAudition/EnrollAudition";
import Chatting from "../Pages/Chatting/Chatting";

import Home from "../../Screen/HomePages";
import ActivitiesLearnNav from "../Pages/LearningPages/LearningSession/ActivitiesLearnNav";
import Market from "../../Screen/MarketPlace/MarketPlace";

import "../../Screen/Post/NewPost.css";
//Don't Delete

import LeftSidebar from "./Sidebar/LeftSidebar";
import RightSidebar from "./Sidebar/RightSidebar";
import AuditionBody from "../Pages/AuditionPages/AuditonBody/AuditionBody";

import "./MasterLayout.css";
import SearchUser from "../Pages/SerachUser/SearchUser";
import VideoHome from "../../Screen/VideoHome";
import ActivitiesBody from "./Sidebar/Left/Activities/ActivitiesBody";
import VideoActivities from "./Sidebar/Left/Activities/Content/VideoActivities";
import Category from "../../Screen/Category/Category";
import ProfileCatBody from "./Sidebar/Left/Category/Content/ProfileCatBody";
import CategoryView from "./Sidebar/Left/Category/Content/CategoryView";
import FollowStar from "./Sidebar/Left/Category/Content/FollowStar";
import FollowUnFollowStar from "./Sidebar/Left/Category/Content/FollowUnFollowStar";
import UnfollowStar from "./Sidebar/Left/Category/Content/UnfollowStar";
import ProfileCat from "./Sidebar/Left/Category/Content/ProfileCat";
import WalletBody from "./Sidebar/Left/Wallet/WalletBody";
import SettingsHome from "../../Screen/SettingsHome";
import FollowMain from "./Sidebar/Left/Following/FollowMain";
import FanGroup from "./Sidebar/Left/FanGroup/FanHome";
import Navigation from "./Header/Navigation";
import Live from "../../Screen/Right/Live";
import UpcomingLive from "../../Screen/Right/UpcomingLive";
import Learn from "../../Screen/Right/Learn";
import Meetup from "../../Screen/Right/Meetup";
import Qna from "../../Screen/Right/Qna";
import UpcomingAuditions from "../../Screen/Right/UpcomingAuditions";
import PromoVideo from "../PromoVideo/PromoVideo";
import About from "../../Screen/Policy/About";
import FAQCard from "../Common/FAQCard";
import Privacy from "../../Screen/Policy/Privacy";
import ProductPFlow from "../../Screen/Policy/ProductPFlow";
import Refund from "../../Screen/Policy/Refund";
import TermsCondition from "../../Screen/Policy/TermsCondition";
import Faq from "../../Screen/Policy/Faq";
import NewNavigation from "./Header/NewNavigation";
import BlinkingAuditions from "./Sidebar/BlinkingAuditions";
import LoyaltyWallet from "../../Screen/LoyaltyWallet/LayaltyWallet";
import Plan from "../../Screen/LoyaltyWallet/Plan";
import LuckySpin from "../../Screen/LoyaltyWallet/LuckySpin";
import UpcomingGreetings from "../../Screen/Right/UpcommingGreetings";

// import WalletBody from "../Sidebar/Left/Wallet/WalletBody";

const Homepage = () => {
  const [onlineUsers, setOnlineUsers] = useState([]);
  const socketData = useContext(socketContext);
  const [totalNotification, setTotalNotification] = useState("");

  // useEffect(() => {
  //   const user_id = localStorage.getItem("auth_id");

  //   // ############## Do Not Remove (Important Socket Code) #################
  //   // socketData.emit("addUser", localStorage.getItem("auth_id"));
  //   socketData.on("getUsers", (users) => {
  //     setOnlineUsers(users);
  //     // alert()
  //   });
  //   // ############## Do Not Remove (Important Socket Code) ##################
  // }, [socketData]);

  return (
        <React.Fragment>
          {/* <NewNavigation /> */}
          <Navigation />
          <div className="homebody ">
            <div className="container-fluid ContainerMobilePost">
              <div className="row d-flex PostRow justify-content-center  ">
                <div className="col-md-3 justify-content-center TabLeftSide individual-scroll desktop-view Lehft-max-width">
                  <div className="promoVideoBorder left-col-box-promo-video ">
                    <PromoVideo />
                  </div>
                  <div>
                  <BlinkingAuditions />
                  </div>

                  <LeftSidebar onlineUserProp={onlineUsers} />

                </div>

                <div className="col-md-6 justify-content-center TabMiddle PostCardWidthMobile Center-max-width">
                  <Switch>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/video" component={VideoHome} />
                    <Route exact path="/marketplace" component={Market} />
                    <Route exact path="/chatting/:id" component={Chatting} />

                    <Route exact path="/category" component={Category} />
                    <Route
                        exact
                        path="/category-view/:slug"
                        component={CategoryView}
                    />
                    <Route
                        exact
                        path="/category-profile/:slug"
                        component={ProfileCat}
                    />
                    <Route
                        exact
                        path="/star-follow-list"
                        component={UnfollowStar}
                    />
                    <Route
                        exact
                        path="/star-following-list"
                        component={FollowStar}
                    />
                    <Route
                        exact
                        path="/star-follow-following-list"
                        component={FollowUnFollowStar}
                    />

                    <Route exact path="/activities" component={ActivitiesBody} />
                    <Route
                        exact
                        path="/learning-activities/:slug"
                        component={ActivitiesLearnNav}
                    />
                    <Route
                        exact
                        path="/learning-activities"
                        component={ActivitiesLearnNav}
                    />
                    <Route
                        exact
                        path="/activities/video/:id"
                        component={VideoActivities}
                    />

                    <Route
                        exact
                        path="/category-view/:slug"
                        component={CategoryView}
                    />
                    <Route
                        exact
                        path="/category-profile"
                        component={ProfileCatBody}
                    />

                    <Route
                        exact
                        path="/learning-activities/:slug"
                        component={ActivitiesLearnNav}
                    />
                    <Route
                        exact
                        path="/learning-activities"
                        component={ActivitiesLearnNav}
                    />
                    <Route
                        exact
                        path="/activities/video/:id"
                        component={VideoActivities}
                    />
                    <Route exact path="/wallet" component={WalletBody} />
                    <Route
                        exact
                        path="/category-view/:slug"
                        component={CategoryView}
                    />
                    <Route
                        exact
                        path="/category-profile"
                        component={ProfileCatBody}
                    />

                    {/* Policy */}
                    <Route exact path="/about-us" component={About} />

                    <Route exact path="/privacy-policy" component={Privacy} />
                    <Route
                        exact
                        path="/product-purchase-flow"
                        component={ProductPFlow}
                    />
                    <Route exact path="/refund-return-policy" component={Refund} />
                    <Route
                        exact
                        path="/terms-condition"
                        component={TermsCondition}
                    />
                    <Route exact path="/faq" component={Faq} />

                    <Route exact path="/following" component={FollowMain} />
                    <Route
                        exact
                        path="/learning-activities/:slug"
                        component={ActivitiesLearnNav}
                    />

                    <Route
                        exact
                        path="/learning-activities"
                        component={ActivitiesLearnNav}
                    />
                    <Route
                        exact
                        path="/activities/video/:id"
                        component={VideoActivities}
                    />
                    <Route exact path="/fan-group" component={FanGroup} />

                    {/* Right Sidebar   */}
                    <Route exact path="/live-now" component={Live} />
                    <Route
                        exact
                        path="/upcoming-greetings"
                        component={UpcomingGreetings}
                    />
                    <Route
                        exact
                        path="/upcoming-learning-sessions"
                        component={Learn}
                    />
                    <Route
                        exact
                        path="/upcoming-live-chat"
                        component={UpcomingLive}
                    />
                    <Route
                        exact
                        path="/upcoming-auditions"
                        component={UpcomingAuditions}
                    />
                    <Route
                        exact
                        path="/upcoming-meetup-events"
                        component={Meetup}
                    />
                    <Route exact path="/upcoming-qna-events" component={Qna} />
                    <Route exact path="/settings" component={SettingsHome} />
                    <Route
                        exact
                        path="/enrolled-auditions"
                        component={EnrollAudition}
                    />
                    <Route exact path="/search/:query" component={SearchUser} />
                    <Route
                        exact
                        path="/enrolled-auditions-round/:slug"
                        component={AuditionBody}
                    />

                    <Route exact path="/loyalty-wallet" component={LoyaltyWallet}/>
                    <Route exact path="/loyalty-wallet/plan" component={Plan}/>
                    <Route exact path="/lucky-spin" component={LuckySpin}/>

                    {/* Right Sidebar End */}
                  </Switch>
                </div>

                <div className="col-md-3 justify-content-center Right-max-width container-fluid RightSideContent individual-scroll">
                  <RightSidebar />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
  );
};

export default Homepage;
